var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"font-serif rounded md:text-white text-lg w-full md:w-40 py-1 transition focus:outline-none hover:bg-gray-200 select-none",class:[_vm.active ?
        'text-flamingo-800 hover:text-flamingo-900 md:hover:text-white md:bg-flamingo-800 md:hover:bg-flamingo-900' :
        'text-olive-300 hover:text-olive-400 md:hover:text-white md:bg-olive-300 md:hover:bg-olive-400'],on:{"click":function($event){_vm.$router.push(_vm.href).catch(()=>{});}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }